import { InputLabel, TextField } from '@material-ui/core'
import { newDate } from 'helpers/dateTools'
import { useFixDate } from 'hooks/useFixDate'
import React from 'react'

export const UpdateDateComponent = ({
  currentDate, date, onChange, onChange2
}) => {
  useFixDate({
    date, action: onChange2
  })
  return (
    <form style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 24 
    }}>
      <InputLabel>Fecha Actual: { currentDate }</InputLabel>
      <TextField 
        type="date"
        label="Nueva fecha"
        name="date"
        value={date}
        variant="outlined"
        // fullWidth
        size='small'
        onChange={onChange}
        inputProps={{
          max: newDate()
        }}
      />
    </form>
  )
}
